import ViewModel from "../ViewModel";
import AuthRepository from "../../../domain/repositories/auth/AuthRepository";
import ChangeListener from "../../../util/ChangeListener";
import BrowserHistoryHelper from "../../../util/BrowserHistoryHelper";
import BaseView from "../../view/BaseView";
import NavbarViewModel from "./NavbarViewModel";
import { countries } from "../../../domain/models/country/countries";
import CountryHolder from "../../../domain/models/country/CountryHolder";
import CountryItem from "../../../domain/models/country/CountryItem";

import RequestOptions from "../../../util/api/RequestOptions";
import ApiHelper from "../../../util/api/ApiHelper";
import { APPLICATION_SERVER } from "../../../constants";


export default class NavbarViewModelImpl extends ViewModel implements NavbarViewModel {
  public isShowDashboardIcon: boolean;
  public isShowUsersIcon: boolean;

  public isShowCountriesList: boolean;
  public countriesList: CountryItem[];
  public selectedCountryItem: CountryItem;

  private countryHolder: CountryHolder;
  private authRepository: AuthRepository;
  private authListener: ChangeListener;

  public constructor(authRepository: AuthRepository, countryHolder: CountryHolder) {
    super();

    this.authRepository = authRepository;
    this.countryHolder = countryHolder;

    this.isShowDashboardIcon = false;
    this.isShowUsersIcon = false;

    this.isShowCountriesList = false;
    this.countriesList = countries;
    this.selectedCountryItem = this.countryHolder.getCountry();

    this.authListener = {
      onChanged: (): void => {
        if (!authRepository.isAuthorized()) {
          BrowserHistoryHelper.moveTo("/login");
        }
      },
    };
  }

  public attachView = (baseView: BaseView): void => {
    super.attachView(baseView);
    this.authRepository.addAuthListener(this.authListener);

    if (!this.authRepository.isAuthorized()) {
      BrowserHistoryHelper.moveTo("/login");
      return;
    } else {
      if (window.location.href.includes("admin") && this.authRepository.getUserRole() === "user") {
        BrowserHistoryHelper.moveTo("/main");
        return;
      }
    }

    if (window.location.href.includes("main")) {
      this.isShowCountriesList = true;

      if (this.authRepository.getUserRole() === "admin") {
        this.isShowUsersIcon = true;
      }
    }

    if (window.location.href.includes("admin")) {
      this.isShowDashboardIcon = true;
    }

    super.notifyViewAboutChanges();
  };

  public detachView = (baseView: BaseView): void => {
    super.detachView(baseView);
    this.authRepository.removeAuthListener(this.authListener);

    this.isShowDashboardIcon = false;
    this.isShowUsersIcon = false;
    this.isShowCountriesList = false;
    this.countriesList = countries;
    this.selectedCountryItem = this.countryHolder.getCountry();
  };

  public onCountrySelected = (countryItem: CountryItem): void => {
    this.selectedCountryItem = countryItem;
    this.countryHolder.saveCountry(countryItem);
    super.notifyViewAboutChanges();
  };

  public onUsersClicked = (): void => {
    BrowserHistoryHelper.moveTo("/admin");
  };

  public onDashboardClicked = (): void => {
    BrowserHistoryHelper.moveTo("/main");
  };

  public onLogoutClicked = (): void => {
    //! new call
    const requestOptions: RequestOptions = new RequestOptions();
    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);
    ApiHelper.fetchGetJson<void>(`${APPLICATION_SERVER}/api/back`, requestOptions);
    //!

    this.authRepository.logout();
};
}
